import { observer } from 'mobx-react-lite';
import * as React from 'react';

export const WelcomePage: React.FC<any> = observer(
	() =>
	{
		return (
			<div className="row no-gutters scrolled-container">
				<div className="col-lg">

					<div className="main-steps-form">
						<div className="form-block-container">

							<p className="mb-2">
								<b>Создание и направление заявления оператора электронного документооборота в ФНС России в интерактивном режиме</b>
							</p>
							<p className="mb-2">
								<b>О сервисе</b>
							</p>
							<p className="mb-2">
								Сервис предназначен для создания заявления оператора ЭДО в формате PDF,
								подписания его квалифицированной электронной подписью руководителя организации,
								действующего от ее имени без доверенности, и направления на рассмотрение в ФНС России
								с целью исполнения требований оператора ЭДО в соответствии с приказом ФНС России
								от 08.06.2021 № ЕД-7-26/546@ и внесения изменений в Реестр операторов ЭДО,
								согласно приказу ФНС России от 29.10.2021 №&nbsp;ЕД-7-26/936@.
							</p>
							<p className="mb-2">
								<b>Особенности работы сервиса</b>
							</p>
							<div className="mb-2">
								Сервис позволяет в интерактивном режиме производить следующие действия:
								<ul>
									<li>Подтверждение регистрационных данных не авторизованным пользователем с помощью электронной почты.</li>
									<li>Формирование заявления оператора ЭДО.</li>
									<li>Подписание квалифицированной электронной подписью сформированного заявления оператора ЭДО.</li>
									<li>Направление подписанного заявления оператора ЭДО в ФНС России.</li>
									<li>Получение подтверждения о регистрации обращения.</li>
								</ul>
							</div>
							<p className="mb-2">
								Будьте внимательны! Формирование заявления выполняется автоматически в соответствии с информацией,
								указываемой пользователем Сервиса в предназначенных полях Сервиса.
								При указании некорректных сведений об услуге или об организации или вложенных документах
								по результатам рассмотрения Вашего заявления ФНС России может быть принято отрицательное решение.
								Перед подписанием заявления Сервис предложит повторно проверить указанные данные.
							</p>
							<p className="mb-2">
								<b>Для работы с сервисом</b>
							</p>
							<p className="mb-2">
								Нажмите на кнопку «Продолжить».
							</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
)
